module.exports = __webpack_public_path__ + "img/5.5df9ab8b.png";